module.exports = __webpack_public_path__ + "img/rinat-akhmetov.10d85672.png";